(function() {
	'use strict';

	angular.module('app.leanProjects')
		.service('viewProjectsService', viewProjectsService);

	function viewProjectsService($http, URLS, leanFilterService) {
		var urlPfx = '2/factndx/';
		return {
			getStageList: getStageList,
			getData: getData,
			saveProject: saveProject,
			getProjectMonthlySavings: getProjectMonthlySavings
		};

		function getStageList(leanDirFactoryNdx, dynamicOnly) {
			var url = URLS.host + String.format(URLS.projectStages, leanDirFactoryNdx);
			if (dynamicOnly) {
				url += '?dynamicOnly=true&grouped=true';
			}
			return $http.get(url)
				.then(getStageListComplete)
				.catch(getStageListFailed);

			function getStageListComplete(response) {
				return response.data;
			}

			function getStageListFailed(error) {
				return [];
			}
		}

		function getData(skipCustomFields, includeAllStages, viewType) {
			var pageUrl;
			pageUrl = buildUrl(skipCustomFields, includeAllStages, viewType);
			return $http.get(URLS.host + pageUrl).then(function(result) {
				return result.data;
			});
		}

		function saveProject(leanProject, leanDirFactoryNdx, lastModified) {
			var url = URLS.host + urlPfx + leanDirFactoryNdx + '/LeanProject/' + leanProject.id;
			if (typeof leanProject.customFieldNdx !== 'undefined') {
				url += '/' + leanProject.customFieldNdx + '/' + leanProject.customFieldType;
				delete leanProject.customFieldNdx;
				delete leanProject.customFieldType;
			}
			return $http.put(url, leanProject, { headers: { 'If-Unmodified-Since': lastModified } })
				.then(saveProjectSuccess)
				.catch(saveProjectFailed);

			function saveProjectSuccess(response) {
				return response;
			}

			function saveProjectFailed(error) {
				return error;
			}
		}

		function buildUrl(skipCustomFields, includeAllStages, viewType) {
			var factories = leanFilterService.getFactoryList();
			var url = urlPfx + factories + '/LeanProjects';
			if (skipCustomFields) {
				url += '?skipCustomFields=true';
			}
			if (typeof includeAllStages !== undefined && includeAllStages) {
				url += (skipCustomFields ? '&' : '?') + 'includeAllStages=true';
			}
			if (typeof viewType !== undefined) {
				url += (skipCustomFields || includeAllStages? '&' : '?') + 'viewType=' + viewType;
			}
			var qParams = '';
			return leanFilterService.addFilterQueryParams(url);
		}

		function getProjectMonthlySavings(leanProject, leanDirFactoryNdx, fiscalYear, fiscalStartMonth) {
			var url = URLS.host + urlPfx + leanDirFactoryNdx + '/LeanProject/' + leanProject + '/MonthlySavings/Year/' + fiscalYear + '/Month/' + fiscalStartMonth;
			return $http.get(url)
				.then(getProjectMonthlySavingsComplete)
				.catch(getProjectMonthlySavingsFailed);

			function getProjectMonthlySavingsComplete(response) {
				return response.data;
			}

			function getProjectMonthlySavingsFailed(error) {
				return [];
			}
		}
	}
})();
